import { render, staticRenderFns } from "./UserGroupSearchResultBeautify.vue?vue&type=template&id=325df54d&scoped=true"
import script from "./UserGroupSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./UserGroupSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSearchResultBeautify.vue?vue&type=style&index=0&id=325df54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325df54d",
  null
  
)

export default component.exports